import { FC, useEffect, useState } from "react";

import { ContactItemDisplay } from "./contact-item.display";
import { ContactItemEdit } from "./contact-item.edit";
import { IContactItemForm } from "./table-contacts.models";

export const ContactItem: FC<IContactItemForm> = ({
  fieldName,
  index,
  value,
  control,
  setValue,
  removeHandler,
  onEditStart,
  onEditEnd,
}) => {
  const [inEdit, setInEdit] = useState(false);

  useEffect(() => {
    if (inEdit) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [inEdit, onEditStart, onEditEnd]);

  return (
    <div className={!inEdit ? "display-mode" : undefined}>
      {!inEdit && (
        <ContactItemDisplay
          fieldName={fieldName}
          setValue={setValue}
          control={control}
          removeHandler={removeHandler}
          index={index}
          value={value}
          onEdit={() => {
            setInEdit(true);
          }}
        />
      )}

      {inEdit && (
        <ContactItemEdit
          fieldName={fieldName}
          setValue={setValue}
          index={index}
          value={value}
          onCancel={() => {
            setInEdit(false);
          }}
        />
      )}
    </div>
  );
};
